module.exports = __webpack_public_path__ + "img/green_exclamation.9444b7f9.svg";